import React from 'react'
import { IoLocationSharp } from "react-icons/io5";
import { CgCloseO } from "react-icons/cg";
import { PiCheckCircleBold } from "react-icons/pi";
import styles from '../../styles/modules/Dashboard.module.css'
import { MdOutlineTimelapse } from 'react-icons/md';

const RSVPCard = ({ request, handleRSVPRequestStatus }) => {
  return (
      <div className={styles['rsvp_request_card']}>
          <div className={styles['rsvp_request_card_vertical_border']}></div>
          <div className={styles['rsvp_request_card_head']}>
              <h3>
                  {new Date(request?.startTime).toLocaleDateString("en-US", { timeZone: 'UTC', month: 'short' })}
              </h3>
              <p>
                  {new Date(request?.startTime).toLocaleDateString("en-US", { timeZone: 'UTC', day: 'numeric' })}
              </p>
          </div>
          <div className={styles['rsvp_request_card_details']}>
              <h4>{request?.scheduleType?.replaceAll("_", " ")}</h4>
              <p className={styles['venue']}><IoLocationSharp className={styles['venue_icon']} /><span>{request?.venue}</span></p>
              <p className={styles['timing']}>
                  <MdOutlineTimelapse className={styles['timing_icon']} />
                  {new Date(request?.startTime).toLocaleTimeString("en-US", {timeZone:'UTC', hour: '2-digit', minute: '2-digit' })}
                  &nbsp;-&nbsp;
                  {new Date(request?.endTime).toLocaleTimeString("en-US", { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' })}
              </p>
          </div>
         { request?.status === 'PENDING' ?
          <div className={styles['rsvp_action_btns']}>
              <button
                type="button"
                className={styles['rsvp_action_text_btn']}
                data-testid="rsvp-decline"
                onClick={() => handleRSVPRequestStatus(request,"REJECTED")}
              >
                <CgCloseO className={styles['reject']} />
                Decline
              </button>
              <button
                type="button"
                className={styles['rsvp_action_text_btn']}
                data-testid="rsvp-accept"
                onClick={() => handleRSVPRequestStatus(request, "ACCEPTED")}
              >
                <PiCheckCircleBold className={styles['accept']} />
                Accept
              </button>
          </div>
          :
          <div className={styles['rsvp_action_cancel_btn']}>
             {request?.status === 'ACCEPTED' && <h4 className={`${styles['rsvp_current_status']} ${styles['accepted']}`}>Accepted</h4>}
              {request?.status === 'REJECTED' &&<h4 className={`${styles['rsvp_current_status']} ${styles['rejected']}`}>Rejected</h4>}
                  <button onClick={() => handleRSVPRequestStatus(request, "PENDING")}>Cancel</button>
          </div>}
      </div>
  )
}

export default RSVPCard